import React from "react";

/**
 * HeaderStats — decorative gradient banner that sits behind the page content.
 * The page content is pulled up with negative top margin (-mt-16 in Admin.js).
 */
export default function HeaderStats() {
  return (
    <div
      className="header-banner w-full hidden md:block"
      style={{ height: "10rem" }}
    />
  );
}
